module.exports = __webpack_public_path__ + "static/media/stanford.288ddb8f.png";